import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { WindowComponent } from '@ibc-shared/components/window/window.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-register-confirmation',
  imports: [WindowComponent, TranslateModule, RouterLink],
  templateUrl: './register-confirmation.component.html',
  styleUrl: './register-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterConfirmationComponent {
  private route = inject(ActivatedRoute);
  protected success = signal<boolean>(this.route.snapshot.data['ok'] === true);
  protected error = signal<boolean>(!this.success());
}
